import React from "react";
import Navbar from "../Navbar";
import { LayoutDashboard } from "lucide-react";

export default function DashboardLayout({
  user,
  title,
  subtitle,
  eyebrow = "Recruiter workspace",
  leftPanel,
  mainContent,
  rightPanel,
  headerAction
}) {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <Navbar />

      {/* 3 PANE LAYOUT */}
      <div className="w-full px-4 pt-20 pb-8 sm:px-6 lg:px-0 lg:pb-0 lg:pt-16">
        <div className={`mx-auto grid w-full max-w-[1760px] gap-6 lg:gap-0 ${
          rightPanel
            ? "lg:grid-cols-[16rem_minmax(0,1fr)_20rem]"
            : "lg:grid-cols-[16rem_minmax(0,1fr)]"
        }`}>

          {/* LEFT */}
          <div className="w-full self-start lg:sticky lg:top-16 lg:h-[calc(100vh-4rem)] lg:bg-[#03140f] lg:p-4">
            {leftPanel}
          </div>

          {/* MAIN */}
          <div className="min-w-0 space-y-6 lg:px-8 lg:pb-8 lg:pt-5">
            <section className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
              <div className="flex min-w-0 flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
                <div className="min-w-0">
                  <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
                    <LayoutDashboard size={14} />
                    {eyebrow}
                  </div>
                  <h1 className="text-2xl font-semibold tracking-tight text-slate-950 md:text-3xl">
                    {title}
                  </h1>
                  {subtitle && (
                    <p className="mt-2 max-w-4xl text-slate-500">
                      {subtitle}
                    </p>
                  )}
                </div>

                {headerAction && (
                  <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center lg:justify-end">
                    {headerAction}
                  </div>
                )}
              </div>
            </section>
            {mainContent}
          </div>

          {/* RIGHT */}
          {rightPanel && (
            <div className="w-full space-y-6 lg:p-8 lg:pl-0">
              {rightPanel}
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
